var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177.575,
    height: 134.553,
    viewBox: "0 0 177.575 134.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ded4cf;}.b{fill:#e5e9ea;}.c{fill:#fde3d5;}.d{fill:#efd0be;}.e,.q,.w{fill:none;stroke-miterlimit:10;}.e{stroke:#845d57;}.e,.q{stroke-linecap:round;stroke-width:0.912px;}.f{fill:#ddc6b6;}.g{fill:#fff;}.h{fill:#eabfb9;}.i{fill:#845d57;}.j{fill:#c5e4ea;}.k{fill:#341c10;}.l{fill:#e3e3e3;}.m{fill:#ededed;}.n{fill:#96c5e8;}.o{fill:#fac9aa;}.p{fill:#dadada;}.q{stroke:#432918;}.r{fill:#d3ac91;}.s{fill:#dd9a8d;}.t{fill:#432918;}.u{fill:#8cd0e5;}.v{fill:#3da4bf;}.w{stroke:#000;stroke-width:2px;}.x{fill:#898b8d;}.y{fill:#e68855;}.z{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 177.575,
    height: 134.553,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "z",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H159.575V116.553H0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.361,8.653h-77.37A3.187,3.187,0,0,1,157.8,5.463V2.272A2.269,2.269,0,0,1,160.072,0h78.289V8.653Z",
    transform: "translate(-78.786)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.958 30.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 3.819,
    height: 3.215,
    transform: "translate(7.517 24.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M324.621,183.088a2.777,2.777,0,0,1,.8.1V182H321.6v3.142A3.033,3.033,0,0,1,324.621,183.088Z",
    transform: "translate(-314.083 -157.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M301.57,193.289h-3.287a7.57,7.57,0,0,0-7.783,6.429h18.853A7.6,7.6,0,0,0,301.57,193.289Z",
    transform: "translate(-290.5 -166.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M312.863,112.255c0,5.559-3.239,10.055-7.831,10.055s-7.831-4.5-7.831-10.055c0-5.535,3.239-10.055,7.831-10.055C309.6,102.2,312.863,106.7,312.863,112.255Z",
    transform: "translate(-295.581 -97.366)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.221 15.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M357.656,149.271c-.169.87.145,1.668.7,1.764s1.136-.532,1.281-1.4c.169-.87-.145-1.668-.7-1.764C358.406,147.773,357.825,148.4,357.656,149.271Z",
    transform: "translate(-357.61 -147.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M361.142,151.4l.1.048a.183.183,0,0,1,.1.048c.024.024.072.048.1.1a.528.528,0,0,1,.073.121.358.358,0,0,1,.024.169,1.131,1.131,0,0,1-.048.387,1.813,1.813,0,0,1-.121.387,1.533,1.533,0,0,1-.169.29c-.024.024-.072.048-.1.072-.024,0-.072.024-.1.024h-.1a.713.713,0,0,0,.1.073c.024.024.073.024.145.048a.6.6,0,0,0,.193-.024.947.947,0,0,0,.338-.29,1.317,1.317,0,0,0,.193-.459.822.822,0,0,0,.024-.242c0-.073-.024-.169-.024-.242a.6.6,0,0,0-.1-.218c-.024-.024-.048-.073-.072-.1s-.073-.048-.1-.073a.23.23,0,0,0-.169-.048c-.048-.024-.1,0-.121,0A.408.408,0,0,0,361.142,151.4Z",
    transform: "translate(-360.105 -150.544)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.558 15.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M294.838,149.271c.169.87-.145,1.668-.7,1.764s-1.136-.532-1.281-1.4c-.169-.87.145-1.668.7-1.764C294.089,147.773,294.669,148.4,294.838,149.271Z",
    transform: "translate(-292.811 -147.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M294.749,151.4l-.1.048a.183.183,0,0,0-.1.048c-.024.024-.072.048-.1.1a.527.527,0,0,0-.073.121.358.358,0,0,0-.024.169,1.131,1.131,0,0,0,.048.387,1.811,1.811,0,0,0,.121.387,1.532,1.532,0,0,0,.169.29c.024.024.073.048.1.072.024,0,.072.024.1.024h.1a.711.711,0,0,1-.1.073c-.024.024-.073.024-.145.048a.6.6,0,0,1-.193-.024.947.947,0,0,1-.338-.29,1.319,1.319,0,0,1-.193-.459.823.823,0,0,1-.024-.242c0-.073.024-.169.024-.242a.6.6,0,0,1,.1-.218c.024-.024.048-.073.073-.1s.073-.048.1-.073a.23.23,0,0,1,.169-.048c.048-.024.1,0,.121,0A.674.674,0,0,1,294.749,151.4Z",
    transform: "translate(-293.713 -150.544)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M305.4,133.595a1.916,1.916,0,0,1,3-.508",
    transform: "translate(-301.799 -120.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M343.2,133.595a1.916,1.916,0,0,0-3-.508",
    transform: "translate(-328.187 -120.398)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.242 18.394)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M326.655,158.3a.289.289,0,0,1,.1.1,1.181,1.181,0,0,1,.218.363.9.9,0,0,1,.048.29.683.683,0,0,1-.1.363c-.048.048-.073.121-.121.145a1.024,1.024,0,0,1-.169.121,2.126,2.126,0,0,1-.363.121c-.121,0-.242.024-.338.024-.121,0-.217-.024-.314-.024a2.888,2.888,0,0,1-.532-.121,3.878,3.878,0,0,1-.483-.218s.217-.024.532-.024h.532c.1,0,.193-.024.29-.024s.193-.024.266-.024c.1-.024.169-.048.242-.072.024-.024.073-.024.1-.048l.072-.073a.389.389,0,0,0,.1-.169.669.669,0,0,0,.024-.218,1.463,1.463,0,0,0-.048-.363A.374.374,0,0,1,326.655,158.3Z",
    transform: "translate(-324.6 -158.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.541 20.811)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M321.7,169a1.979,1.979,0,0,0,3.771,0Z",
    transform: "translate(-321.7 -168.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M321.7,168.469a3.6,3.6,0,0,0,.363.483l.218.218c.072.073.169.121.242.193a2.563,2.563,0,0,0,.508.266l.29.072.29.024.29-.024c.1-.024.169-.048.266-.072a1.976,1.976,0,0,0,.483-.29c.073-.073.145-.121.218-.193s.121-.145.193-.218a2.088,2.088,0,0,0,.169-.242l.145-.266.145.218c-.628,0-1.257-.024-1.885-.048C322.957,168.566,322.328,168.542,321.7,168.469Zm0,0c.628-.048,1.257-.1,1.885-.121s1.257-.048,1.885-.048h0a.139.139,0,0,1,.145.145.089.089,0,0,1-.024.073,2.633,2.633,0,0,1-.338.556,2.179,2.179,0,0,1-.218.242c-.072.073-.169.145-.242.218s-.193.121-.266.193c-.1.048-.193.1-.314.145-.1.024-.218.048-.338.073-.121,0-.193.024-.314.024-.121-.024-.217-.024-.338-.048a1.565,1.565,0,0,1-.314-.1,2.632,2.632,0,0,1-.556-.338,1.845,1.845,0,0,1-.217-.218,1.689,1.689,0,0,1-.193-.242c-.048-.1-.121-.169-.169-.266Z",
    transform: "translate(-321.7 -168.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.327 14.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M310.9,141.643a.892.892,0,0,1-.8.943.876.876,0,0,1-.8-.943.892.892,0,0,1,.8-.943A.876.876,0,0,1,310.9,141.643Z",
    transform: "translate(-309.082 -140.7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M309.173,141.787a.387.387,0,1,1-.387-.387A.4.4,0,0,1,309.173,141.787Z",
    transform: "translate(-308.4 -141.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M310.438,144.757a.169.169,0,1,1-.169-.169C310.366,144.564,310.438,144.661,310.438,144.757Z",
    transform: "translate(-309.689 -143.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.496 14.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M342.2,141.643a.892.892,0,0,0,.8.943.876.876,0,0,0,.8-.943.892.892,0,0,0-.8-.943A.876.876,0,0,0,342.2,141.643Z",
    transform: "translate(-342.2 -140.7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.039 0.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M346.5,141.787a.387.387,0,1,0,.387-.387A.4.4,0,0,0,346.5,141.787Z",
    transform: "translate(-346.5 -141.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M346.6,144.757a.169.169,0,1,0,.169-.169C346.672,144.564,346.6,144.661,346.6,144.757Z",
    transform: "translate(-346.576 -143.815)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M314.679,193.617a8.289,8.289,0,0,1,1.716.7s-2.224,3.722.749,5.39H304.6c2.2-1.692.58-5.583.58-5.583a8.959,8.959,0,0,1,3.5-.846l1.837,2.03,1.958-2.03A7.085,7.085,0,0,1,314.679,193.617Z",
    transform: "translate(-301.192 -166.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M297.1,147.9",
    transform: "translate(-295.505 -132.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M315.2,103",
    transform: "translate(-309.23 -97.973)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.16 18.346)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M296.363,158.632a.532.532,0,1,1-.532-.532A.536.536,0,0,1,296.363,158.632Z",
    transform: "translate(-295.3 -158.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M296.315,158.877a.446.446,0,0,1-.29.121.4.4,0,0,1-.29-.121.446.446,0,0,1-.121-.29h0a.4.4,0,0,1,.121-.29.307.307,0,0,1,.169-.1h-.073a.532.532,0,0,0,0,1.063.544.544,0,0,0,.508-.387Z",
    transform: "translate(-295.3 -158.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M297.887,159.093a.193.193,0,1,1-.193-.193A.191.191,0,0,1,297.887,159.093Z",
    transform: "translate(-296.968 -158.707)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.484 18.346)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M359.763,158.632a.532.532,0,1,1-.532-.532A.536.536,0,0,1,359.763,158.632Z",
    transform: "translate(-358.7 -158.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M359.715,158.877a.446.446,0,0,1-.29.121.4.4,0,0,1-.29-.121.446.446,0,0,1-.121-.29h0a.4.4,0,0,1,.121-.29.307.307,0,0,1,.169-.1h-.072a.532.532,0,1,0,0,1.063.544.544,0,0,0,.508-.387Z",
    transform: "translate(-358.7 -158.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M361.287,159.093a.193.193,0,1,1-.193-.193A.178.178,0,0,1,361.287,159.093Z",
    transform: "translate(-360.368 -158.707)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M303.812,91.182a8.786,8.786,0,0,1,6.719,5.656c.894,3.529-.387,8.46-.387,8.46l-.266,1.4h-.29a14.293,14.293,0,0,0-.483-6.26c-1.5-4.375-6.816-4.061-6.816-4.061-5.052.073-6.55,3.191-6.55,3.191-1.764,2.006-1.281,7.13-1.281,7.13h-.242l-.242-1.378a25.749,25.749,0,0,1-.7-6.115c-.266-6.284,5.922-7.88,5.922-7.88A27.447,27.447,0,0,1,303.812,91.182Z",
    transform: "translate(-292.597 -88.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M320.791,85.052c0,1.571-2.006,2.852-4.5,2.852s-4.5-1.281-4.5-2.852,2.006-2.852,4.5-2.852C318.761,82.2,320.791,83.481,320.791,85.052Z",
    transform: "translate(-306.652 -82.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.502 26.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M317.4,202.223a3.863,3.863,0,0,1,2.876-1.184S318.077,200,317.4,202.223Z",
    transform: "translate(-317.4 -198.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M318.439,193.314l1.837,2.03s-2.079-.483-2.876,1.184l.048-3.142A3.113,3.113,0,0,1,318.439,193.314Z",
    transform: "translate(-317.4 -193.287)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.354 26.857)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M332.1,202.49a3.746,3.746,0,0,0-2.8-1.305S331.524,200.242,332.1,202.49Z",
    transform: "translate(-329.276 -199.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M331.158,193.336l-1.958,2.03s2.1-.387,2.8,1.305l.145-3.263A3.113,3.113,0,0,0,331.158,193.336Z",
    transform: "translate(-329.2 -193.316)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.722 26.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 6.212,
    height: 5.245,
    transform: "translate(12.206 39.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M70.807,221.34a5.684,5.684,0,0,1,1.305.145V219.6H65.9v5.124A4.972,4.972,0,0,1,70.807,221.34Z",
    transform: "translate(-53.694 -180.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M33.383,237.984H28.065S17.43,237.4,15.4,248.449H46.048C43.994,237.428,33.383,237.984,33.383,237.984Z",
    transform: "translate(-15.4 -194.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M51.5,106.139c0,9.016-5.269,16.339-12.738,16.339S26,115.179,26,106.139C26,97.124,31.269,89.8,38.738,89.8,46.231,89.824,51.5,97.124,51.5,106.139Z",
    transform: "translate(-23.438 -81.945)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.372 25.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M124.578,166.329c-.266,1.426.242,2.707,1.136,2.876s1.837-.846,2.1-2.272-.242-2.707-1.136-2.876C125.787,163.912,124.844,164.927,124.578,166.329Z",
    transform: "translate(-124.508 -164.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130.211,169.715s.048.024.169.073c.048.024.121.024.169.073a.821.821,0,0,1,.145.145.486.486,0,0,1,.1.193c.048.073.024.169.048.266a2.863,2.863,0,0,1-.048.628,3.554,3.554,0,0,1-.193.6,1.248,1.248,0,0,1-.29.459.434.434,0,0,1-.169.121c-.048,0-.121.048-.169.024a.773.773,0,0,0-.169-.024,1.481,1.481,0,0,0,.145.121c.048.048.121.048.218.073a.768.768,0,0,0,.314-.048,1.431,1.431,0,0,0,.532-.483,2.586,2.586,0,0,0,.314-.749,2.381,2.381,0,0,0,.048-.411,1.2,1.2,0,0,0-.048-.411,1,1,0,0,0-.169-.363c-.048-.048-.073-.1-.121-.145-.048-.024-.1-.072-.145-.1a.815.815,0,0,0-.29-.1.653.653,0,0,0-.218,0A.756.756,0,0,0,130.211,169.715Z",
    transform: "translate(-128.521 -168.299)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.872 25.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M22.317,166.329c.266,1.426-.242,2.707-1.136,2.876s-1.837-.846-2.1-2.272.242-2.707,1.136-2.876C21.109,163.912,22.051,164.927,22.317,166.329Z",
    transform: "translate(-19.008 -164.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M22.515,169.715s-.048.024-.169.073c-.048.024-.121.024-.169.073a.821.821,0,0,0-.145.145.486.486,0,0,0-.1.193c-.048.073-.024.169-.048.266a1.936,1.936,0,0,0,.073.628,3.554,3.554,0,0,0,.193.6,1.666,1.666,0,0,0,.29.459.434.434,0,0,0,.169.121c.048,0,.121.048.169.024a.773.773,0,0,1,.169-.024,1.483,1.483,0,0,1-.145.121c-.048.048-.121.048-.218.073a.768.768,0,0,1-.314-.048,1.432,1.432,0,0,1-.532-.483,2.587,2.587,0,0,1-.314-.749,2.381,2.381,0,0,1-.048-.411,1.2,1.2,0,0,1,.048-.411A1,1,0,0,1,21.6,170c.048-.048.073-.1.121-.145.048-.024.1-.072.145-.1a.815.815,0,0,1,.29-.1.653.653,0,0,1,.218,0Z",
    transform: "translate(-20.801 -168.299)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M39.5,140.778s1.692-3.094,4.882-.846",
    transform: "translate(-33.675 -119.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M100.882,140.778s-1.692-3.094-4.882-.846",
    transform: "translate(-76.518 -119.338)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.342 29.899)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M73.984,181a.863.863,0,0,1,.169.169,1.733,1.733,0,0,1,.338.58,1.314,1.314,0,0,1,.1.483,1.129,1.129,0,0,1-.169.58,2.57,2.57,0,0,0-.218.266,1,1,0,0,1-.266.169,2.725,2.725,0,0,1-.58.193,4.716,4.716,0,0,1-.556.048,3.95,3.95,0,0,1-.532-.048,3.807,3.807,0,0,1-.87-.218,8.561,8.561,0,0,1-.8-.363,7.287,7.287,0,0,1,.87-.048c.266,0,.556-.024.846,0,.145,0,.314-.024.459-.024.169,0,.29-.048.459-.048.145-.024.266-.073.387-.1a1.179,1.179,0,0,1,.169-.073l.121-.1a.938.938,0,0,0,.145-.266,1.427,1.427,0,0,0,.048-.338,1.886,1.886,0,0,0-.073-.58A1.644,1.644,0,0,1,73.984,181Z",
    transform: "translate(-70.6 -181)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.255 33.863)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M66.1,198.5a3.231,3.231,0,0,0,6.139,0Z",
    transform: "translate(-66.1 -198.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M66.1,197.666a4.815,4.815,0,0,0,.58.8,4.465,4.465,0,0,0,.338.338,4.029,4.029,0,0,0,.387.29,2.667,2.667,0,0,0,1.305.532l.459.024.483-.048c.145-.048.29-.073.411-.121a3.264,3.264,0,0,0,.8-.459,2.087,2.087,0,0,0,.338-.314c.1-.121.218-.218.314-.363a2.19,2.19,0,0,0,.266-.387l.242-.411.218.363c-1.015,0-2.055-.024-3.07-.073C68.13,197.811,67.115,197.763,66.1,197.666Zm0,0c1.015-.1,2.055-.145,3.07-.193s2.055-.073,3.07-.073h0a.242.242,0,0,1,.242.242.218.218,0,0,1-.024.121,5.565,5.565,0,0,1-.556.894c-.1.145-.242.266-.338.387-.121.121-.266.242-.411.363a4.536,4.536,0,0,1-.435.29,4.253,4.253,0,0,1-.483.218c-.169.048-.363.1-.532.145a3.4,3.4,0,0,1-.508.024c-.169-.024-.363-.048-.532-.073a4.157,4.157,0,0,1-.508-.169,3.454,3.454,0,0,1-.894-.556,5.12,5.12,0,0,1-.363-.363c-.1-.145-.218-.266-.314-.411a4.2,4.2,0,0,1-.266-.435Z",
    transform: "translate(-66.1 -197.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.034 22.986)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M48.41,153.923a1.321,1.321,0,1,1-1.305-1.523A1.421,1.421,0,0,1,48.41,153.923Z",
    transform: "translate(-45.486 -152.4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.709,154.3a.6.6,0,1,1-.6-.6A.6.6,0,0,1,45.709,154.3Z",
    transform: "translate(-44.5 -153.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.58,158.99a.29.29,0,1,1-.29-.29A.279.279,0,0,1,47.58,158.99Z",
    transform: "translate(-46.396 -157.491)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.279 22.986)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M99.3,153.923a1.321,1.321,0,1,0,1.305-1.523A1.437,1.437,0,0,0,99.3,153.923Z",
    transform: "translate(-99.3 -152.4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.716 0.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M106.4,154.3a.6.6,0,1,0,.6-.6A.6.6,0,0,0,106.4,154.3Z",
    transform: "translate(-106.4 -153.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M106.5,158.99a.29.29,0,1,0,.29-.29A.294.294,0,0,0,106.5,158.99Z",
    transform: "translate(-106.476 -157.491)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M54.688,238.425a12.49,12.49,0,0,1,2.78,1.136s-3.626,6.043,1.233,8.774H38.3c3.553-2.755.967-9.088.967-9.088A14.972,14.972,0,0,1,45,237.869l2.973,3.311,3.166-3.287A11.947,11.947,0,0,1,54.688,238.425Z",
    transform: "translate(-32.765 -194.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M26,164.1",
    transform: "translate(-23.438 -138.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M55.4,91.1",
    transform: "translate(-45.732 -82.93)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.837 29.827)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M24.74,181.57a.87.87,0,1,1-.87-.87A.867.867,0,0,1,24.74,181.57Z",
    transform: "translate(-23 -180.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M24.744,181.936a.677.677,0,0,1-1.16-.483h0a.719.719,0,0,1,.193-.483.58.58,0,0,1,.29-.169h-.1a.87.87,0,0,0,0,1.74.856.856,0,0,0,.822-.628C24.768,181.912,24.768,181.912,24.744,181.936Z",
    transform: "translate(-23.076 -180.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M27.328,182.306a.314.314,0,1,1-.314-.314A.291.291,0,0,1,27.328,182.306Z",
    transform: "translate(-25.806 -181.678)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.781 29.827)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M127.94,181.57a.87.87,0,1,1-.87-.87A.867.867,0,0,1,127.94,181.57Z",
    transform: "translate(-126.2 -180.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M127.944,181.936a.677.677,0,0,1-1.16-.483h0a.719.719,0,0,1,.193-.483.58.58,0,0,1,.29-.169h-.1a.87.87,0,0,0,0,1.74.856.856,0,0,0,.822-.628C127.968,181.912,127.968,181.912,127.944,181.936Z",
    transform: "translate(-126.276 -180.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M130.528,182.306a.314.314,0,1,1-.314-.314A.291.291,0,0,1,130.528,182.306Z",
    transform: "translate(-129.006 -181.678)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M36.679,71.947a14.194,14.194,0,0,1,10.9,9.185c1.426,5.728-.653,13.777-.653,13.777l-.411,2.3h-.483c1.015-4.447-.773-10.176-.773-10.176-2.417-7.13-11.094-6.6-11.094-6.6-8.218.121-10.659,5.173-10.659,5.173-2.876,3.287-2.079,11.6-2.079,11.6h-.387l-.411-2.248a41.517,41.517,0,0,1-1.16-9.934c-.363-10.248,9.692-12.81,9.692-12.81S34.939,71.584,36.679,71.947Z",
    transform: "translate(-18.479 -68.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M64.447,61.941c0,2.562-3.263,4.641-7.324,4.641-4.036,0-7.324-2.079-7.324-4.641S53.063,57.3,57.124,57.3C61.16,57.3,64.447,59.379,64.447,61.941Z",
    transform: "translate(-41.485 -57.3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.538 43.675)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M59,252.5a6.27,6.27,0,0,1,4.665-1.934S60.088,248.871,59,252.5Z",
    transform: "translate(-59 -247.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M60.768,238.043l3,3.311s-3.384-.773-4.665,1.934l.048-5.1A3.9,3.9,0,0,1,60.768,238.043Z",
    transform: "translate(-59.076 -237.993)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.203 43.679)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M82.868,252.9a6.24,6.24,0,0,0-4.568-2.151C78.3,250.774,81.95,249.227,82.868,252.9Z",
    transform: "translate(-78.3 -247.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M81.491,238.056,78.3,241.343s3.408-.628,4.568,2.151l.242-5.318A4.022,4.022,0,0,0,81.491,238.056Z",
    transform: "translate(-78.3 -238.01)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M170.547,256.844a4.533,4.533,0,0,0,2.345-2.731c.387.943.773,1.861,1.16,2.8a2.286,2.286,0,0,0,1.426-2.127c1.813.822,3.916.266,5.8-.314-1.716-.218-3.408-.435-5.124-.677-1.184-.145-2.828-.7-3.988-.363-1.329.411-2.151,2.054-2.683,3.239-.169.363-.314.749-.483,1.136.387-1.837.894-3.722,1.45-5.511.048.773.024,1.547.048,2.32A9.938,9.938,0,0,1,170.547,256.844Z",
    transform: "translate(-112.464 -174.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M320.791,258.337c-.169-.29.314-.532.7-.653,1.909-.556,3.819-1.112,5.7-1.668a2.347,2.347,0,0,1,1.136,2.828,5.021,5.021,0,0,1-3.843-.653c-.556-.387-.943-1.039-.532-1.5a2.008,2.008,0,0,1,1.16-.459c.773-.145,1.547-.29,2.32-.459a4.591,4.591,0,0,1,1.982-.072,4.181,4.181,0,0,1,1.6,1.209,2.1,2.1,0,0,0,1.958.6,10.616,10.616,0,0,0-3.384-.121c-1.112.193-2.151.846-2.272,1.716l.725-2.538c.314.991.628,2.006.943,3a6.366,6.366,0,0,0,.87-2.393c.024.749.048,1.474.048,2.224a6.159,6.159,0,0,0,1.523-3.263c.435,1.958.87,3.891,1.354,5.849a6.523,6.523,0,0,0,1.885-3.384,25.5,25.5,0,0,0-6.671-.483c-1.354.024-2.9.121-3.722.943a41.67,41.67,0,0,0,8.75-4.762c-.459,1.885-.919,3.771-1.4,5.656a25.005,25.005,0,0,1,7.517-5.1",
    transform: "translate(-211.641 -174.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 29,
    height: 4,
    rx: 2,
    transform: "translate(3 2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 40,
    height: 3,
    rx: 1.5,
    transform: "translate(53.177 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 21,
    height: 2,
    rx: 1,
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(49.066 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "translate(49.066 23.063)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(49.066 47.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(49.066 66.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(48.04 52.745)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 11,
    height: 1,
    rx: 0.5,
    transform: "translate(48.282 35.056)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 14,
    height: 1,
    rx: 0.5,
    transform: "translate(63.957 35.056)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 14,
    height: 1,
    rx: 0.5,
    transform: "translate(48.663 37.753)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(50.772 28.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28,
    height: 1,
    rx: 0.5,
    transform: "translate(76.883 47.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28,
    height: 1,
    rx: 0.5,
    transform: "translate(76.883 67.417)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(63.085 52.745)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 18,
    height: 1,
    rx: 0.5,
    transform: "translate(49.206 57.978)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(48.534 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28,
    height: 4,
    rx: 2,
    transform: "translate(6 103.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 147.873,
    height: 4,
    rx: 2,
    transform: "translate(6 110.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28,
    height: 4,
    rx: 2,
    transform: "translate(52.223 103.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 47,
    height: 4,
    rx: 2,
    transform: "translate(106.873 103.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(77.252 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 20,
    height: 3,
    rx: 1.5,
    transform: "translate(49.494 90.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 18,
    height: 3,
    rx: 1.5,
    transform: "translate(109.658 90.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(129.873 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 12,
    height: 1,
    rx: 0.5,
    transform: "translate(103.729 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 12,
    height: 1,
    rx: 0.5,
    transform: "translate(103.729 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(78.506 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(107.945 9)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(132.873 48.992)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(116.383 66.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(134.873 66.27)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.543d41a9c00180eee18b7b45bebefed9.svg";
export { ForwardRef as ReactComponent };